import { boolean, object, type ObjectSchema } from 'yup';

import { FormErrorMessage } from '~/constants/messages';

import { Fields } from './types';

export const validationSchema = object({
  active: boolean().label('ステータス').required(FormErrorMessage.required),
  useCustomSetting: boolean().label('個別設定').required(FormErrorMessage.required),
}) as ObjectSchema<Fields>;
